import React from 'react';
import { motion } from 'framer-motion';
import { Smartphone, Moon, Frown } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <Smartphone size={22} className="text-pastel-pink" data-id="element-258" />,
    title: 'Demasiadas pantallas',
    desc: 'Cuesta despegarlos del celular sin enojos.'
  }, {
    icon: <Moon size={22} className="text-pastel-lavender-dark" data-id="element-259" />,
    title: 'Noches difíciles',
    desc: 'Les cuesta conciliar el sueño y descansar.'
  }, {
    icon: <Frown size={22} className="text-pastel-aqua" data-id="element-260" />,
    title: 'Ansiedad y berrinches',
    desc: 'Desbordes emocionales difíciles de calmar.'
  }];
  return <section className="py-12 bg-pastel-white" data-id="element-261">
      <div className="container mx-auto px-5 sm:px-8 lg:px-12" data-id="element-262">
        <div className="text-center max-w-2xl mx-auto mb-8" data-id="element-263">
          <h2 className="text-2xl md:text-3xl font-display font-bold text-gray-900 mb-2" data-id="element-264">
            ¿Te resulta familiar?
          </h2>
          <p className="text-base text-gray-600" data-id="element-265">
            La vida moderna impacta el bienestar de nuestros hijos.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 max-w-4xl mx-auto" data-id="element-266">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="glass-card rounded-2xl p-4 flex items-center gap-3 hover:-translate-y-0.5 transition-transform duration-300" data-id="element-267">
              <div className="w-10 h-10 shrink-0 bg-white rounded-full flex items-center justify-center shadow-sm" data-id="element-268">
                {problem.icon}
              </div>
              <div className="text-left" data-id="element-269">
                <h3 className="text-sm font-display font-bold text-gray-800 leading-tight" data-id="element-270">
                  {problem.title}
                </h3>
                <p className="text-xs text-gray-600 leading-snug" data-id="element-271">
                  {problem.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}